// @flow

import _ from 'lodash';

import ReduceStore from 'PMT/flux/ReduceStore';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import KioskSettings from 'PMT/entities/restaurant/KioskSettings';

function objectCopy(obj: ApiObject) {
  return _.isNil(obj) ? obj : obj.copy();
}

class KioskSettingsStore extends ReduceStore {

  getInitialState() {
    return {
      // ApiError
      apiError: null,

      // KioskSettings
      kioskSettings: null,
    };
  }

  getStateObjectsMap() {
    return {
      payoutList: new ApiError(),
      kioskSettings: new KioskSettings(),
    }
  }

  getApiError(): ApiError {
    return objectCopy(this._state.apiError);
  }

  getSettings(): KioskSettings {
    return objectCopy(this._state.kioskSettings);
  }

  areEqual(one: TState, two: TState): boolean {
    const isEqual = _.isEqual(one, two);
    return isEqual;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.GET_KIOSK_SETTINGS_SUCCESS:
      case ActionTypes.PUT_KIOSK_SETTINGS_SUCCESS:
        nextState.kioskSettings = action.kioskSettings;
        return nextState;

      case ActionTypes.GET_KIOSK_SETTINGS_FAILURE:
      case ActionTypes.PUT_KIOSK_SETTINGS_FAILURE:
        nextState.apiError = null;
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new KioskSettingsStore();
